import Logo from 'assets/images/logo.png';
import Cart from 'assets/svgs/Cart';
import Hamburger from 'assets/svgs/Hamburger';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleSidebar } from 'redux/reducers/sidebarReducer';

const Navbar = () => {
    const dispatch = useDispatch();
    const { showSidebar } = useSelector(state => state.sidebar)

    return (
        <div className='border-b fixed left-0 w-full top-0 bg-pure z-10'>
            <div className='flex items-center justify-between gap-2 md:px-20 sm:px-12 px-4 py-4'>
                <div>
                    <Link to='/user/dashboard'>
                        <img 
                        src={Logo} 
                        alt="Logo"
                        className='md:w-full sm:w-[120px] w-[100px]' 
                        />
                    </Link>
                </div>
                <div className='flex items-center gap-6'>
                    <Link to='/user/new-compaign' className='sm:block hidden'>
                        <button className="btn-primary py-1 5">
                            Create Compaign
                        </button>
                    </Link>
                    <div className='round-icon'>
                        <Link to='/user/cart'>
                            <Cart />
                        </Link>
                    </div>
                    <div 
                    className='md:hidden block cursor-pointer'
                    onClick={() => {
                        dispatch(toggleSidebar(showSidebar ? false : true))
                    }}
                    >
                        <Hamburger />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar;